
import React from 'react';
import Layout from '@/components/Layout/Layout';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight, Calculator } from 'lucide-react';

const Calculators = () => {
  const calculatorTypes = [
    {
      title: 'Standard Calculator',
      description: 'Basic calculator with addition, subtraction, multiplication, and division.',
      path: '/calculators/standard',
      icon: <Calculator className="w-10 h-10 text-primary" />
    },
    {
      title: 'Scientific Calculator',
      description: 'Advanced calculator with trigonometric, logarithmic, and exponential functions.',
      path: '/calculators/scientific',
      icon: <Calculator className="w-10 h-10 text-blue-500" />
    },
    {
      title: 'Graphing Calculator',
      description: 'Visual calculator for plotting functions and equations on a coordinate plane.',
      path: '/calculators/graphing',
      icon: <Calculator className="w-10 h-10 text-green-500" />
    },
    {
      title: 'Programming Calculator',
      description: 'Specialized calculator for binary, octal, and hexadecimal operations.',
      path: '/calculators/programming',
      icon: <Calculator className="w-10 h-10 text-purple-500" />
    },
    {
      title: 'Date Calculator',
      description: 'Calculate differences between dates or add/subtract time periods.',
      path: '/calculators/date',
      icon: <Calculator className="w-10 h-10 text-orange-500" />
    }
  ];

  return (
    <Layout>
      <div className="max-w-5xl mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Calculators</h1>
          <p className="text-gray-600">
            Choose from our range of specialized calculators designed for different calculation needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {calculatorTypes.map((calc, index) => (
            <Link key={index} to={calc.path} className="block">
              <Card className="h-full transition-shadow hover:shadow-md">
                <CardContent className="p-6 flex flex-col h-full">
                  <div className="mb-4">
                    {calc.icon}
                  </div>
                  <h2 className="text-xl font-semibold mb-2">{calc.title}</h2>
                  <p className="text-gray-600 flex-grow">{calc.description}</p>
                  <div className="flex items-center mt-4 text-primary font-medium">
                    <span>Open Calculator</span>
                    <ArrowRight className="ml-2 w-4 h-4" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Calculators;
